<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >登录密码</el-breadcrumb-item>
            <el-breadcrumb-item>设置密码</el-breadcrumb-item>
        </el-breadcrumb>
            <div class="step_wrap">
                <el-steps :active="active" finish-status="success" align-center>
                    <el-step title="安全验证"></el-step>
                    <el-step title="设置密码"></el-step>
                    <el-step title="设置成功"></el-step>
                </el-steps>
            </div>
            <div class="form_wrap" v-if="isShow">
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                     <el-form-item label="原密码" prop="originpass" autocomplete="off">
                        <el-input v-model="ruleForm.originpass"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="pass">
                        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                   
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="satatus_box"  v-if="status">
                <el-container>
                    <el-aside width="200px" class="tips">
                        <el-button type="success" size="medium " icon="el-icon-check" circle></el-button>
                        </el-aside>
                    <el-main>
                        <el-header>
                           <div>修改密码成功！</div> 
                        <span>下次登录必须使用新密码才能登录</span>
                          <div class="line"></div>
                        </el-header>
                        <el-footer>
                            <el-button type="info" plain @click="close()">关闭</el-button>
                        </el-footer>
                    </el-main>
                </el-container>
            </div>
        
    </div>
</template>

<script>
import {changePass} from '@/api/userFun';

export default {
    name:'password',
    data(){
        return{
            active:2,
            isShow:true,
            status:false,
            ruleForm: {
            pass: '',
            checkPass: '',
            originpass: ''//原密码
                },
            rules: {
                pass: [
                    { validator: this.validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: this.validatePass2, trigger: 'blur' }
                ],
                originpass: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ]
            },
      
        }
    },
         methods: {

                close(){
                    this.$router.push({
                        path:'/'
                    })

                },

              validatePass(rule, value, callback) {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else {
                     var reg=/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,}$/;
                    if(!reg.test(value)){ 
                        callback(new Error('要求8位以上,包含数字,大小写字母,特殊符号'));
                        }else{
                        callback();
                    }
                }
             },
                validatePass2 (rule, value, callback) {
                if (value === '') {
                callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
                } else {
                callback();
                }
            },

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    changePass(this.ruleForm).then(res=>{
                        this.active=3;
                    this.status=true;
                    this.isShow=false;
                    })
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$nextTick(()=>{
                    this.$refs[formName].resetFields();
                })
                
        }
    }
}
    

</script>

<style scoped>

.step_wrap{
    max-width: 1000px;
    margin: 20px auto;
}
.form_wrap{
    max-width: 500px;
    margin: 0 auto;
}
.satatus_box{
    max-width: 500px;
    margin:50px auto;
    background: #f2f2f2;
    }
    .tips{
        display: flex;
        align-items: center;
        justify-content: center;
       
    }
    .el-button--medium.is-circle {
        padding: 26px;
    }
    .el-button--medium{
        font-size: 20px;
    }
    .line{
        height: 1px;
        background: #ccc;
        margin-top: 10px;
        margin-bottom: 20px;
       
    }
    .el-header{
        padding: 0;
    }
</style>


// WEBPACK FOOTER //
// src/views/setting/password.vue